import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import {
    COMPLETION_OPTIONS,
    RefundAuditOption as Option,
    STATUS_OPTIONS,
    previousMonthDefaults,
} from './refundAuditFilters';

const RefundAuditAccordionItem: React.FC = () => {
    const navigate = useNavigate();
    const defaults = previousMonthDefaults();
    const [fromDate, setFromDate] = useState(defaults.from);
    const [toDate, setToDate] = useState(defaults.to);
    const [status, setStatus] = useState<Option | null>(null);
    const [completion, setCompletion] = useState<Option | null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const params = new URLSearchParams();
        if (fromDate) params.set('from_date', fromDate);
        if (toDate) params.set('to_date', toDate);
        if (status) params.set('status', status.value);
        if (completion) params.set('completion_status', completion.value);
        navigate(`/reports/predefined/refund-audit/results?${params.toString()}`);
    };

    return (
        <div className='flex h-full w-full flex-col rounded-sm border border-stroke bg-white px-7.5 py-5 shadow-default'>
            <h4 className='text-title-xsm font-bold sm:text-title-md'>
                Refund Audit Trail
            </h4>
            <p className='mt-2 text-sm text-body'>
                Every refund issued from the portal, with the Stripe charge,
                refund, and payout IDs needed to reconcile against Stripe and
                the bank statement. Defaults to the previous calendar month.
            </p>
            <form onSubmit={handleSubmit} className='mt-4 flex flex-1 flex-col'>
                <div className='flex flex-col gap-4 sm:flex-row'>
                    <div>
                        <label className='mb-1 block text-[12px] font-bold'>
                            From
                        </label>
                        <input
                            type='date'
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className='h-10 rounded border border-gray-400 px-3 text-sm'
                        />
                    </div>
                    <div>
                        <label className='mb-1 block text-[12px] font-bold'>
                            To
                        </label>
                        <input
                            type='date'
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            className='h-10 rounded border border-gray-400 px-3 text-sm'
                        />
                    </div>
                </div>
                <div className='mt-4 flex flex-col gap-4 sm:flex-row'>
                    <div className='flex-1'>
                        <label className='mb-1 block text-[12px] font-bold'>
                            Refund Status
                        </label>
                        <Select
                            menuPlacement='auto'
                            options={STATUS_OPTIONS}
                            isClearable
                            value={status}
                            onChange={(opt) => setStatus(opt as Option | null)}
                            placeholder='Any status'
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '40px',
                                }),
                            }}
                        />
                    </div>
                    <div className='flex-1'>
                        <label className='mb-1 block text-[12px] font-bold'>
                            RE/MIP Entered
                        </label>
                        <Select
                            menuPlacement='auto'
                            options={COMPLETION_OPTIONS}
                            isClearable
                            value={completion}
                            onChange={(opt) =>
                                setCompletion(opt as Option | null)
                            }
                            placeholder='Any'
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '40px',
                                }),
                            }}
                        />
                    </div>
                </div>
                <div className='mt-auto pt-6'>
                    <button
                        type='submit'
                        className='rounded-lg bg-primary px-8 py-3 text-sm font-medium text-white'
                    >
                        Run report
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RefundAuditAccordionItem;
